import { useState, useEffect, useCallback } from 'react';

export const usePWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const installHandler = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    const installedHandler = () => setDeferredPrompt(null);

    window.addEventListener('beforeinstallprompt', installHandler);
    window.addEventListener('appinstalled', installedHandler);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((readyRegistration) => {
        setRegistration(readyRegistration);
        if (readyRegistration.waiting) setIsUpdateAvailable(true);

        readyRegistration.addEventListener('updatefound', () => {
          const worker = readyRegistration.installing;
          if (!worker) return;
          worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              setIsUpdateAvailable(true);
            }
          });
        });
      }).catch((error) => console.warn('Service Worker nicht bereit:', error));
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', installHandler);
      window.removeEventListener('appinstalled', installedHandler);
    };
  }, []);

  const installPWA = useCallback(async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setDeferredPrompt(null);
    return outcome === 'accepted';
  }, [deferredPrompt]);

  const reloadPage = useCallback(() => {
    const waitingWorker = registration?.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      return;
    }
    window.location.reload();
  }, [registration]);

  return {
    isInstallable: Boolean(deferredPrompt),
    installPWA,
    isUpdateAvailable,
    reloadPage,
  };
};
